import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  Button,
  Grid,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import StepCircle from "../StepCircle";
import api from "../../api";
import { Autocomplete } from "@mui/material";

const steps = ["Datos Básicos", "Licencia", "Asignar Vehículo"];

const EditarConductor = ({ conductor, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [vehiculos, setVehiculos] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  const [licenciaFileName, setLicenciaFileName] = useState(null);
  const [licenciaFileURL, setLicenciaFileURL] = useState(null);

  const [conductorData, setConductorData] = useState({
    nombre: "",
    apellido: "",
    numero_licencia: "",
    categoria_licencia: "",
    vencimiento_licencia: "",
    area: "",
    pin: "",
    telefono: "",
    email: "",
    licencia: null,
    observaciones: "",
    vehiculos_asignados: [],
  });

  useEffect(() => {
    api.get("vehiculos/")
      .then((res) => setVehiculos(res.data))
      .catch(() => alert("Error al cargar vehículos."));
  }, []);

  useEffect(() => {
    if (conductor) {
      console.log("Actualizando conductorData con:", conductor);
      setConductorData({
        nombre: conductor.nombre || "",
        apellido: conductor.apellido || "",
        numero_licencia: conductor.numero_licencia || "",
        categoria_licencia: conductor.categoria_licencia || "",
        vencimiento_licencia: conductor.vencimiento_licencia || "",
        area: conductor.area || "",
        pin: conductor.pin || "",
        telefono: conductor.telefono || "",
        email: conductor.email || "",
        observaciones: conductor.observaciones || "",
        vehiculos_asignados: conductor.vehiculos_asignados || [],
        licencia: null,  // file is not fetched; only uploaded
      });
      if (conductor.licencia) {
        setLicenciaFileURL(conductor.licencia);
        setLicenciaFileName(conductor.licencia.split("/").pop());
      }
    }
  }, [conductor]);


  useEffect(() => {
    const { nombre, apellido, numero_licencia, telefono, email } = conductorData;
    setIsStep1Valid(nombre && apellido && numero_licencia);
  }, [conductorData]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "licencia") {
      setConductorData({ ...conductorData, licencia: files[0] });
    } else {
      setConductorData({ ...conductorData, [name]: value });
    }
  };

  const handleVehiculosChange = (event) => {
    const {
      target: { value },
    } = event;
    setConductorData({
      ...conductorData,
      vehiculos_asignados: typeof value === 'string' ? value.split(',') : value,
    });
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    Object.entries(conductorData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((v) => formData.append(key, v)); // ✅ no []
        } else {
          formData.append(key, value);
        }
      }
    });

    api
      .put(`conductores/${conductor.id}/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => api.get(`conductores/${conductor.id}/`))
      .then((res) => {
        alert("Conductor actualizado correctamente");
        onUpdate?.(res.data);
        handleClose();
      })
      .catch((err) => {
        console.error(err);
        alert("Error al actualizar el conductor.");
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "600px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Editar Conductor
      </Typography>

      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={6}>
            <TextField label="Nombre" name="nombre" value={conductorData.nombre} onChange={handleChange} fullWidth required />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Apellido" name="apellido" value={conductorData.apellido} onChange={handleChange} fullWidth required />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Número de Licencia" name="numero_licencia" value={conductorData.numero_licencia} onChange={handleChange} fullWidth required />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Categoría Licencia" name="categoria_licencia" value={conductorData.categoria_licencia} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Vencimiento Licencia"
              name="vencimiento_licencia"
              type="date"
              value={conductorData.vencimiento_licencia}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Área" name="area" value={conductorData.area} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={6}>
            <TextField label="PIN" name="pin" value={conductorData.pin} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Teléfono" name="telefono" value={conductorData.telefono} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Email" name="email" type="email" value={conductorData.email} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" fullWidth onClick={handleNext} sx={{ background: "#152d51" }} disabled={!isStep1Valid}>
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <Button variant="outlined" component="label" fullWidth>
              Subir nueva Licencia
              <input
                type="file"
                hidden
                name="licencia"
                accept="application/pdf,image/*"
                onChange={(e) => {
                  setConductorData({
                    ...conductorData,
                    licencia: e.target.files[0],
                  });
                }}
              />
            </Button>

            {conductorData.licencia ? (
              <Typography sx={{ mt: 1 }}>
                Archivo seleccionado: {conductorData.licencia.name}
              </Typography>
            ) : licenciaFileName ? (
              <Typography sx={{ mt: 1 }}>
                Archivo actual:{" "}
                <a href={licenciaFileURL} target="_blank" rel="noopener noreferrer">
                  {licenciaFileName}
                </a>
              </Typography>
            ) : null}
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Observaciones"
              name="observaciones"
              value={conductorData.observaciones}
              onChange={handleChange}
              multiline
              rows={4}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="contained" fullWidth onClick={handleNext} sx={{ background: "#152d51" }}>
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 2 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              fullWidth
              options={vehiculos}
              getOptionLabel={(option) => `${option.patente} - ${option.marca} ${option.modelo}`}
              value={vehiculos.filter((v) => conductorData.vehiculos_asignados.includes(v.id))}
              onChange={(event, newValue) => {
                setConductorData({
                  ...conductorData,
                  vehiculos_asignados: newValue.map((v) => v.id),
                });
              }}
              renderInput={(params) => (
                <TextField {...params} label="Vehículos Asignados" placeholder="Buscar vehículo..." />
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  <strong>{option.patente}</strong> — {option.marca} {option.modelo}
                  {option.conductores?.length > 0 && (
                    <Typography variant="caption" sx={{ marginLeft: 1, color: "gray" }}>
                      ({option.conductores.length} asignado/s)
                    </Typography>
                  )}
                </li>
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ background: "#152d51" }}>
              Guardar Cambios
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default EditarConductor;
